// extracted by mini-css-extract-plugin
export default {"cls1":"ChurnedUserReactivationButton-cls1_gly","cls2":"ChurnedUserReactivationButton-cls2_udp ChurnedUserReactivationButton-cls1_gly"};